import { render, staticRenderFns } from "./SocialActions.vue?vue&type=template&id=307f1f3e&scoped=true&"
import script from "./SocialActions.vue?vue&type=script&lang=ts&"
export * from "./SocialActions.vue?vue&type=script&lang=ts&"
import style0 from "./SocialActions.vue?vue&type=style&index=0&id=307f1f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307f1f3e",
  null
  
)

export default component.exports